import { ROUTES } from '@dashboard/router/routeNames'
import type { RouteRecordRaw } from 'vue-router'
import { requireHostedPages } from './pagesAccess'

const routes: RouteRecordRaw[] = [
  {
    name: ROUTES.PAGES,
    path: 'pages',
    component: () => import('./pages/PagesIndex.vue'),
    beforeEnter: requireHostedPages,
    meta: {
      title: 'Pages',
      description: 'Landing pages RightMessage hosts for you, on your own address.'
    }
  },
  {
    name: ROUTES.PAGE_NEW,
    path: 'pages/new',
    component: () => import('./pages/NewPage.vue'),
    beforeEnter: requireHostedPages,
    meta: { title: 'New page' }
  },
  {
    name: ROUTES.PAGE_EDITOR,
    path: 'pages/:pageId',
    component: () => import('./pages/PageEditor.vue'),
    props: true,
    beforeEnter: requireHostedPages,
    meta: {
      title: 'Page editor',
      fullScreen: true,
      rightyPrompts: [
        { label: 'Make the headline punchier', prompt: 'Make the headline punchier' },
        { label: 'Add a frequently asked questions section', prompt: 'Add a frequently asked questions section' },
        { label: 'Make every button rounder', prompt: 'Make every button rounder' }
      ]
    }
  }
]
export default routes
